import dynamic from 'next/dynamic';
import styles from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import { useEffect } from 'react';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function OceanSmartElectricalPanel40() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        if (typeof window !== 'undefined' && window.AniContainer) {
            return () => AniContainer.destroy();
        }
    }, []);

    return (
        <div className={`ocean-pro-home-solar-battery ${styles['ocean-pro-home-solar-battery']}`}>
            <IndexDynamic />
        </div>
    );
}
